export default __webpack_public_path__ + "static/media/paper_presentation.633e90f4.jpg";